import { PAYMENT_METHOD_TYPE } from '@/models/payment';

export function getPaymentMethodLabel({ type, cardLast4, linkEmail }) {
	if (type === PAYMENT_METHOD_TYPE.CARD) {
		return `**** **** **** ${cardLast4}`;
	}

	if (type === PAYMENT_METHOD_TYPE.PAYPAL) {
		return 'PayPal';
	}

	if (type === PAYMENT_METHOD_TYPE.LINK) {
		return linkEmail;
	}

	return '';
}
